import {Component} from "@angular/core";
import {NavbarComponent} from "../../../components/navbar/navbar.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'cluster-engineering-header',
  standalone: true,
  imports: [
    NavbarComponent,
    TranslateModule
  ],
  styleUrl: '../cluster-engineering.scss',
  templateUrl: 'cluster-engineering-header.html'
})
export class ClusterEngineeringHeader {

}
